<template>
  <div>
    <div :class="['top-nav', (open ? 'true' : '')]">
      <header>
        <div class="menu-icon" @click="toggleMenu" v-if="!open"><i class="fas fa-bars fa-2x"></i></div>
        <div class="logo animated fadeInRight"><router-link to="/"><img src="../assets/logo.png"></router-link></div>
        <nav v-bind:class="{ open: open }" @click="hideMenu">
          <div class="close-icon" @click="toggleMenu"><i class="fas fa-times fa-2x"></i></div>
          <div class="links animated fadeInRight">

            
            <div v-show="open || !subClass">
              <router-link to="/">Home</router-link>
              <router-link to="/the-firm">The Firm</router-link><div class="spacer">&nbsp;</div>
              <router-link to="/capabilities">Capabilities</router-link><div class="spacer">&nbsp;</div>
              <router-link to="/our-people">People</router-link><div class="spacer">&nbsp;</div>
              <router-link to="/insights">Insights</router-link><div class="spacer">&nbsp;</div>
            </div>
            <router-link v-show="!open" to="#" @click.native="toggleSubMenu()" :class="['animated', ((subClass || open) ? 'slideInUp' : 'slideInDown') ]">More <i :class="['fas', (subClass ? 'fa-minus' : 'fa-plus') ]">&nbsp;</i></router-link>
            <router-link to="/" v-if="!subClass" @click.native="toggleSearch()"><i class="fas fa-search"></i></router-link>
            <div :class="['sub-menu','animated', ((subClass || open) ? 'fadeInUp' : 'fadeOutDown') ]" v-show="subOpen || open">
              <router-link to="/careers">Careers</router-link><div class="spacer">&nbsp;</div>
              <router-link to="/contact-us">Contact Us</router-link><div class="spacer">&nbsp;</div>
              <div class="social-media">
                <a :href="socialMedia.field_linkedin[0].value" target="_blank" v-if="socialMedia && socialMedia.field_linkedin && socialMedia.field_linkedin[0] && socialMedia.field_linkedin[0].value"><i class="fab fa-linkedin"></i></a>
                <a :href="socialMedia.field_facebook[0].value" target="_blank" v-if="socialMedia && socialMedia.field_facebook && socialMedia.field_facebook[0] && socialMedia.field_facebook[0].value"><i class="fab fa-facebook-square"></i></a>
                <a :href="socialMedia.field_twitter[0].value" target="_blank" v-if="socialMedia && socialMedia.field_twitter && socialMedia.field_twitter[0] && socialMedia.field_twitter[0].value"><i class="fab fa-twitter-square"></i></a>
                <a :href="socialMedia.field_instagram[0].value" target="_blank" v-if="socialMedia && socialMedia.field_instagram && socialMedia.field_instagram[0] && socialMedia.field_instagram[0].value"><i class="fab fa-instagram"></i></a>
              </div>
            </div>

          </div>
        </nav>
      </header>
      
    </div>
    <div class="searchBar animated slideInUp" v-show="searchOpen">
      <div class="search-close-icon" @click="toggleSearch"><i class="fas fa-times fa-2x"></i></div>
      <h3>Search</h3>
      <div class="search-bar">
        <b-form-input v-model="searchWord" placeholder="Search..." @change="searchSite()"></b-form-input>
        <b-button type="submit" variant="success" @click="searchSite"><i class="fas fa-search"></i></b-button>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapActions } from 'vuex' 
  import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  const ContentRepository = RepositoryFactory.get("content");


  export default {
    data() {
      return{
        open: false,
        subOpen: 0,
        subClass: false,
        socialMedia: null,
        searchOpen: false,
        searchWord: null
      }
    },
    methods: {
      toggleMenu(){
        this.open = !this.open
      },
      toggleSearch(){
        this.searchOpen = !this.searchOpen
      },
      hideMenu(){
        this.open = false
      },
      toggleSubMenu(){
        this.subOpen = this.subOpen + 1
        this.subClass = !this.subClass
      },

      searchSite(){
        console.log('search word', this.searchWord)
        var path = '/search?q='+this.searchWord
        this.toggleSearch()
        this.$router.push(path)
      },
      async getSocialMedia(){
        var type = "social_media_links"
        var id = "61"
        const { data } = await ContentRepository.get(type, id)

        this.socialMedia = data[0]
        // console.log('data', this.socialMedia)

        

  
      },
      ...mapActions(['showModal'])
    },
    mounted(){
      this.getSocialMedia()
    }
  }
</script>


<style scoped>

  nav a{
    margin: 0px 5px 0px 5px;
  }

  .search-bar{
    margin:35px 5% 0px 5%;
    display:grid;
    grid-template-columns: 1fr 80px;
  }

  .search-bar input{
    height:60px;
  }

  .searchBar{
    position:fixed !important;
    top:0;
    left:0;
    bottom:0;
    width:100%;
    background:rgba(0,0,0,0.9);
    z-index:600;
  }

  .top-nav{
    background-image: linear-gradient(rgba(255,255,255,1), rgba(255,255,255,0.2));
    position:fixed;
    top:0;
    height:100vh;
    width:250px;
    right:0;
    xborder:1px solid red;
    z-index:200;
    xoverflow-y:scroll;
    /*border:1px solid red;*/
  }


  .searchBar h3{
    color:green;
    text-transform:uppercase;
    margin-top:30vh;
  }



  

  .menu-icon{
    cursor:pointer;
    position:absolute;
    /*top:50px;
    left:50px;*/
    color:#000;
    z-index:101;
    opacity:0;
  }

  .logo{
    margin-top:25px;
    margin-right:15px;
    xfloat:left;
    text-align:left;
    xdisplay:inline-block;
  }

  .logo img{
    height:75px;
  }


  .close-icon{
    display:block;
    position:absolute;
    z-index:600;
    color:#000;
    opacity:0;
  }

  .search-close-icon{
    display:block;
    position:absolute;
    right:25px;
    top:15px;
    z-index:600;
    color:#FFF;
  }

  nav{
    margin-right:40px;
    margin-top:25px;
    font-size:18px;
    font-weight:bold;
  }

  nav .far{
    font-size:50%;
  }

  header{
    text-align:left;
  }


  /*nav{
    opacity:0;
    background:rgba(0,0,0,0.9);
    position:absolute;
    width:100%;
    padding:0;
    bottom:0;
    left:0;
    z-index:100;
    height:100vh;
    width:1px;
    overflow:hidden;
    padding:20px 20px;
    text-align:left;
    transition: all .3s;
  }

  nav.open{
    opacity: 1;
    width:350px;
    xheight:100vh;
    top:0;
    bottom:0;
    padding-top:35px;
    padding-left:90px;
    bottom:auto;
    transition: all .3s;
  }
*/
  nav a{
    /*display:block;*/
    color:#000;
    text-transform:uppercase;
    margin-top:15px;
    padding-bottom:20px;
    margin-left:40px;
    display:block;
    text-align:right;
    text-decoration:none;

  }

  .social-media a{
    display:inline-block;
    text-decoration:none;
    margin-left:10px;
    color:#CCCCCC !important;
  }

  .social-media{
    text-align:right;
  }

  .sub-menu{
    margin-right:-40px;
    padding-right:40px;
    padding-top:10px;
    padding-bottom:15px;
    background: rgba(0,0,0,0.8);
  }

  .sub-menu a{
    color:#FFF;
    text-decoration:none;
  }

  div.spacer{
    height:5px !important;
    width:5px !important;
    display:inline-block;
    margin:0 10px;
    background-color:#000;
    background:#000;
    margin-bottom:2px;
    display:none;
  }



  @media (max-width:768px){
     nav.open{
      width:100%;
    }

    .links{
      display:none;
    }

    nav.open .links{
      display:block;
    }

    nav.open .links a{
      text-align:center;
    }

    nav.open .social-media{
      text-align:center;
      padding-left:30px;
      padding-right:0;
    }

    nav.open .social-media a{
      margin-right:5px;
      margin-left:5px;
    }



   /* .menu-icon, .close-icon{
      top:10px;
      left:10px;
    }*/

    .menu-icon{
      opacity:1;
      position:absolute;
      top:10px !important;
      right:10px !important;
    }

    nav.open .close-icon{
      opacity:1;
      position:absolute;
      top:10px !important;
      right:10px !important;
    }

    .top-nav.true{
      height:400vh;
    }



    .top-nav{
      width:100%;
      left:0;
      height:auto;
      z-index:600;
      xposition:sticky !important;
    }

    header {
      width:100% !important;
    }

    .logo{
      text-align:center;
    }

    .logo a{
      display:inline;
    }
  }

</style>
